import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { ImageLoadingComponent } from '@common/image-loading/image-loading.component';
import { LastOrderId, LinkifyPipe, NewLineToHtml, SafeHTML, TimestampDisplay } from '@common/pipes';
import { UniversalLinkComponent } from '@common/universal-link/universal-link.component';
import { LinkToUrl } from '@common/link-pipes';
import { ProductMeta, Rating, Rating_SkuInfo } from '@proto/store/api/common/common';
import { Links } from '@helper/links';
import { Urls } from '@helper/urls';
import { ImageSize } from '@helper/image-size';

@Component({
  selector: 'app-rating-list',
  templateUrl: './rating-list.component.html',
  styleUrls: ['./rating-list.component.scss'],
  imports: [
    ImageLoadingComponent,
    LastOrderId,
    TimestampDisplay,
    LinkifyPipe,
    NewLineToHtml,
    SafeHTML,
    UniversalLinkComponent,
    LinkToUrl,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingListComponent {
  readonly orderDisplayDigits = 4;
  readonly ssrImageSuffix: ImageSize = '@2x';
  readonly allowClick = input(true);
  readonly newWindow = input(false);
  readonly showName = input(false);
  readonly itemWidthCss = input('1010px');
  readonly imageSize = input(120);
  readonly horizontalGap = input(60);
  readonly horizontalPadding = input(110);
  readonly itemVerticalPadding = input(20);
  readonly itemGap = input(30);
  readonly ratings = input<Rating[]>([]);
  readonly skuInfos = input<{ [key: string]: Rating_SkuInfo }>({});
  readonly productMetas = input<{ [key: string]: ProductMeta }>({});
  readonly ratingContainerWidth = input.required();

  private readonly router = inject(Router);

  openProduct(skuId: string): void {
    if (!this.allowClick()) {
      return;
    }
    if (this.newWindow()) {
      return;
    }
    Links.handleLink(this.router, Urls.fromSkuId(skuId));
  }
}
